









import Vue from 'vue'

export default Vue.extend({
  props: {
    columns: {
      type: Array,
      default: () => ([])
    },
    dataValue: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {
      tableColumns: [{
        title: this.$t('page_alarm_alarmcode'),
        dataIndex: 'code',
        key: 'code'
      },{
        title: this.$t('page_alarm_alarmcount'),
        dataIndex: 'count',
        key: 'count'
      }],
      tableData: []
    }
  },
  methods:{
  }
})

